import { computed, inject } from '@angular/core';
import { patchState, signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';
import { proxyViewSignal } from 'state-data';
import { PromotionStore } from '../../global-stores/promotion.store';

export function withPromotionEntity() {
  return signalStoreFeature(
    withState({ selectedPromotionId: null as string | null }),

    withMethods((store) => ({
      setSelectedPromotionId(id: string | null): void {
        patchState(store, { selectedPromotionId: id });
      },
    })),

    withComputed((store) => {
      const promotionStore = inject(PromotionStore);
      const id = store.selectedPromotionId;

      return {
        promotionDetail: proxyViewSignal(
          computed(() => {
            const promotionId = id();
            return promotionId ? promotionStore.getPromotion(promotionId) : undefined;
          }),
        ),
      };
    }),
  );
}
